import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating a view
import { allpayments } from 'models/allpayments'; // Importing allpayments model for data handling
import { devConfig } from 'config/config'; // Importing development configuration settings

/**
 * Class representing a view for withdrawal requests.
 * @extends JetView
 */
export default class tableWithdrawalRequestView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        // Retrieve the localization service and its translation function
        const _ = this.app.getService('locale')._;
        // Format the date according to the application's configuration
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat);
        // Get the current user parameter from the request
        const cur_user = this.getParam('user', true);

        // Define the form for unlocking a user by password
        const desbloquear_usuario_clave = {
            view: 'form', // Specify the view type as a form
            margin: 10, // Set the margin around the form
            css: 'secutity prm-customersSecurityChangesUserClaveSwitch', // Apply custom CSS classes
            id: 'desbloquearclaveestadoUsuario', // Unique identifier for the form
            hidden: !devConfig.getPermAction('customersSecurityChangesUserClaveSwitch', 'Switch'), // Determine visibility based on permissions
            rows: [
                // Define the rows within the form
                { view: 'label', label: _('Desbloquear Usuario por Clave') }, // Label for the form
                {
                    css: 'centrar', // Apply centering CSS class
                    id: 'UnlockUserByPassword', // Unique identifier for the button
                    view: 'button', // Specify the view type as a button
                    labelWidth: 55, // Set the width of the label
                    value: _('Desbloquear'), // Button label for unlocking
                    click: () => {
                        // Define the click event handler for the button
                        webix
                            .ajax() // Initiate an AJAX request
                            .headers({
                                'Content-type': 'application/json', // Set the content type to JSON
                            })
                            .post(
                                devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint for updating user security
                                '{"Action":"UnlockUserByPassword","Id":' + cur_user + ',"IsActivate":"A"}', // Request payload
                                {
                                    error: function(text, data, XmlHttpRequest) {
                                        // Error callback
                                        webix.message({
                                            title: _('¡Error!'), // Title for the error message
                                            type: 'alert-error', // Type of message
                                            text: _('Ocurrio un error.'), // Error message text
                                        });
                                    },
                                    success: function(text, data, XmlHttpRequest) {
                                        // Success callback
                                        text = JSON.parse(text); // Parse the response text
                                        if (text.HasError) {
                                            // Check for errors in the response
                                            webix.message({
                                                title: _('¡Error!'), // Title for the error message
                                                type: 'alert-error', // Type of message
                                                text: _('Ocurrio un error.'), // Error message text
                                            });
                                        } else {
                                            webix.message(_('Cambios Realizados')); // Success message
                                        }
                                    },
                                },
                            );
                    },
                },
            ],
        };
        const send_code_mobile = {
            /**
             * Configuration object for the mobile code sending form.
             * @type {Object}
             */
            view: 'form', // Specifies the view type as a form
            margin: 10, // Sets the margin around the form
            css: 'secutity prm-customersSecuritySendCodeMobileSwitch', // CSS classes for styling
            hidden: !devConfig.getPermAction('customersSecuritySendCodeMobileSwitch', 'Switch'), // Determines visibility based on permissions
            rows: [
                // Array of elements within the form
                { view: 'label', label: _('Enviar código al celular') }, // Label for the form
                {
                    css: 'centrar', // CSS class for centering the button
                    id: 'sendCodeMobile', // Unique identifier for the button
                    view: 'button', // Specifies the view type as a button
                    labelWidth: 55, // Width of the label next to the button
                    value: _('Enviar'), // Button text
                    click: () => {
                        // Click event handler for the button
                        webix
                            .ajax() // Initiates an AJAX request
                            .headers({
                                'Content-type': 'application/json', // Sets the content type for the request
                            })
                            .post(
                                devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint for the request
                                '{"Action":"SendCodeMobile","Id":' + cur_user + '}', // Request payload with action and user ID
                                {
                                    error: function(text, data, XmlHttpRequest) {
                                        // Error callback for the AJAX request
                                        webix.message({
                                            title: _('¡Error!'), // Title for the error message
                                            type: 'alert-error', // Type of message
                                            text: _('Ocurrio un error.'), // Error message text
                                        });
                                    },
                                    success: function(text, data, XmlHttpRequest) {
                                        // Success callback for the AJAX request
                                        text = JSON.parse(text); // Parses the response text to JSON
                                        if (text.HasError) {
                                            // Checks if the response indicates an error
                                            webix.message({
                                                title: _('¡Error!'), // Title for the error message
                                                type: 'alert-error', // Type of message
                                                text: _('Ocurrio un error.'), // Error message text
                                            });
                                        } else {
                                            webix.message(_('Código enviado')); // Success message indicating the code was sent
                                        }
                                    },
                                },
                            );
                    },
                },
            ],
        };

        const left = {
            margin: 0, // Margin for the left layout
            autoheight: true, // Automatically adjust height
            rows: [
                {
                    margin: 0, // Margin for the layout
                    css: 'on-row', // CSS class for styling
                    id: 'a1', // Unique identifier for this layout
                    cols: [ // Array of columns in the layout
                        desbloquear_usuario_clave, // Reference to another component or variable
                        {
                            view: 'form', // Form view for user input
                            margin: 10, // Margin for the form
                            css: 'secutity prm-customersSecurityGeneratePasswordSwitch', // CSS classes for styling
                            id: 'generatePassword', // Unique identifier for the form
                            hidden: !devConfig.getPermAction('customersSecurityGeneratePasswordSwitch', 'Switch'), // Conditional visibility based on permissions
                            rows: [ // Array of rows in the form
                                {
                                    view: 'label', // Label for the form
                                    label: _('Generar contraseña'), // Text for the label
                                },
                                {
                                    css: 'centrar', // CSS class for centering
                                    id: 'GeneratePassword', // Unique identifier for the button
                                    view: 'button', // Button view
                                    labelWidth: 55, // Width of the label next to the button
                                    value: _('Generar'), // Text for the button
                                    click: () => { // Click event handler for the button
                                        webix
                                            .ajax() // AJAX request to the server
                                            .headers({
                                                'Content-type': 'application/json', // Setting content type for the request
                                            })
                                            .post(
                                                devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint for updating user security
                                                '{"Action":"GeneratePassword","Id":' + cur_user + ',"IsActivate":"A"}', // Request payload
                                                {
                                                    error: function(text, data, XmlHttpRequest) { // Error handling
                                                        webix.message({
                                                            title: _('¡Error!'), // Error title
                                                            type: 'alert-error', // Error type for styling
                                                            text: _('Ocurrio un error.'), // Error message
                                                        });
                                                    },
                                                    success: function(text, data, XmlHttpRequest) { // Success handling
                                                        text = JSON.parse(text); // Parsing the response text
                                                        if (text.HasError) { // Checking for errors in the response
                                                            webix.message({
                                                                title: _('¡Error!'), // Error title
                                                                type: 'alert-error', // Error type for styling
                                                                text: _('Ocurrio un error.'), // Error message
                                                            });
                                                        } else {
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                        }
                                                    },
                                                },
                                            );
                                    },
                                },
                            ],
                        },
                        {
                            view: 'form', // Another form view for generating a second password
                            margin: 10, // Margin for the form
                            css: 'secutity prm-customersSecurityGeneratePassword2Switch', // CSS classes for styling
                            id: 'generatePassword', // Unique identifier for the form
                            hidden: !devConfig.getPermAction('customersSecurityGeneratePassword2Switch', 'Switch'), // Conditional visibility based on permissions
                            rows: [ // Array of rows in the form
                                {
                                    view: 'label', // Label for the form
                                    label: _('Generar contraseña'), // Text for the label
                                },
                                {
                                    css: 'centrar', // CSS class for centering
                                    id: 'GeneratePassword2', // Unique identifier for the button
                                    view: 'button', // Button view
                                    labelWidth: 55, // Width of the label next to the button
                                    value: _('Generar'), // Text for the button
                                    click: () => { // Click event handler for the button
                                        webix
                                            .ajax() // AJAX request to the server
                                            .headers({
                                                'Content-type': 'application/json', // Setting content type for the request
                                            })
                                            .post(
                                                devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint for updating user security
                                                '{"Action":"GeneratePassword2","Id":' + cur_user + ',"IsActivate":"A"}', // Request payload
                                                {
                                                    error: function(text, data, XmlHttpRequest) { // Error handling
                                                        webix.message({
                                                            title: _('¡Error!'), // Error title
                                                            type: 'alert-error', // Error type for styling
                                                            text: _('Ocurrio un error.'), // Error message
                                                        });
                                                    },
                                                    success: function(text, data, XmlHttpRequest) { // Success handling
                                                        text = JSON.parse(text); // Parsing the response text
                                                        if (text.HasError) { // Checking for errors in the response
                                                            webix.message({
                                                                title: _('¡Error!'), // Error title
                                                                type: 'alert-error', // Error type for styling
                                                                text: _('Ocurrio un error.'), // Error message
                                                            });
                                                        } else {
                                                            webix.message({
                                                                title: _('Contraseña cambiada'), // Success title
                                                                type: 'alert-warning', // Warning type for styling
                                                                text: text.Data, // Success message with additional data
                                                            });
                                                        }
                                                    },
                                                },
                                            );
                                    },
                                },
                            ],
                        },
                        {
                            view: 'form', // Form view for changing user state
                            hidden: !devConfig.getPermAction('customersSecurityChangesUserEstadoSwitch', 'Switch'), // Conditional visibility based on permissions
                            css: 'secutity prm-customersSecurityChangesUserEstadoSwitch', // CSS classes for styling
                            id: 'estadoUsuario', // Unique identifier for the form
                            rows: [ // Array of rows in the form
                                {
                                    view: 'label', // Label for the form
                                    label: _('Estado de Usuario'), // Text for the label
                                },
                                {
                                    css: 'centrar', // CSS class for centering
                                    id: 'StateSwith', // Unique identifier for the switch
                                    view: 'switch', // Switch view for toggling user state
                                    labelWidth: 55, // Width of the label next to the switch
                                    onLabel: _('Activo'), // Label for the "on" state
                                    offLabel: _('Inactivo'), // Label for the "off" state
                                    click: () => { // Click event handler for the switch
                                        if ($$('StateSwith').getValue() == 1) { // Checking if the switch is on
                                            webix
                                                .ajax() // AJAX request to the server
                                                .headers({
                                                    'Content-type': 'application/json', // Setting content type for the request
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint for updating user security
                                                    '{"Action":"State","Id":' + cur_user + ',"IsActivate":"A"}', // Request payload
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error handling
                                                            webix.message({
                                                                title: _('¡Error!'), // Error title
                                                                type: 'alert-error', // Error type for styling
                                                                text: _('Ocurrio un error.'), // Error message
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success handling
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StateSwith').setValue(1); // Setting the switch value
                                                        },
                                                    },
                                                );
                                        } else {
                                            webix
                                                .ajax() // AJAX request to the server
                                                .headers({
                                                    'Content-type': 'application/json', // Setting content type for the request
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint for updating user security
                                                    '{"Action":"State","Id":' + cur_user + ',"IsActivate":"I"}', // Request payload
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error handling
                                                            webix.message({
                                                                title: _('¡Error!'), // Error title
                                                                type: 'alert-error', // Error type for styling
                                                                text: _('Ocurrio un error.'), // Error message
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success handling
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StateSwith').setValue(0); // Setting the switch value
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            ],
                        },
                        {
                            view: 'form', // Form view for contingency state
                            id: 'Contingency', // Unique identifier for the form
                            hidden: !devConfig.getPermAction('customersSecurityChangesEstadoContingenciaSwitch', 'Switch'), // Conditional visibility based on permissions
                            css: 'secutity prm-customersSecurityChangesEstadoContingenciaSwitch', // CSS classes for styling
                            rows: [ // Array of rows in the form
                                {
                                    view: 'label', // Label for the form
                                    label: _('Estado de Contingencia'), // Text for the label
                                },
                                {
                                    id: 'StateContingencySwith', // Unique identifier for the switch
                                    view: 'switch', // Switch view for toggling contingency state
                                    labelWidth: 55, // Width of the label next to the switch
                                    onLabel: _('Activo'), // Label for the "on" state
                                    offLabel: _('Inactivo'), // Label for the "off" state
                                    click: () => { // Click event handler for the switch
                                        if ($$('StateContingencySwith').getValue() == 1) { // Checking if the switch is on
                                            webix
                                                .ajax() // AJAX request to the server
                                                .headers({
                                                    'Content-type': 'application/json', // Setting content type for the request
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint for updating user security
                                                    '{"Action":"Contingency","Id":' + cur_user + ',"IsActivate":"A"}', // Request payload
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error handling
                                                            webix.message({
                                                                title: _('¡Error!'), // Error title
                                                                type: 'alert-error', // Error type for styling
                                                                text: _('Ocurrio un error.'), // Error message
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success handling
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StateContingencySwith').setValue(1); // Setting the switch value
                                                        },
                                                    },
                                                );
                                        } else {
                                            webix
                                                .ajax() // AJAX request to the server
                                                .headers({
                                                    'Content-type': 'application/json', // Setting content type for the request
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint for updating user security
                                                    '{"Action":"Contingency","Id":' + cur_user + ',"IsActivate":"I"}', // Request payload
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error handling
                                                            webix.message({
                                                                title: _('¡Error!'), // Error title
                                                                type: 'alert-error', // Error type for styling
                                                                text: _('Ocurrio un error.'), // Error message
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success handling
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StateContingencySwith').setValue(0); // Setting the switch value
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            ],
                        },
                        {
                            view: 'form', // Form view for special state
                            id: 'Special', // Unique identifier for the form
                            hidden: !devConfig.getPermAction('customersSecurityChangesStateSpecialSwitch', 'Switch'), // Conditional visibility based on permissions
                            css: 'secutity prm-customersSecurityChangesStateSpecialSwitch', // CSS classes for styling
                            rows: [ // Array of rows in the form
                                { view: 'label', label: _('Estado Especial') }, // Label for the form
                                {
                                    id: 'StateSpecialSwith', // Unique identifier for the switch
                                    view: 'switch', // Switch view for toggling special state
                                    labelWidth: 55, // Width of the label next to the switch
                                    onLabel: _('Activo'), // Label for the "on" state
                                    offLabel: _('Inactivo'), // Label for the "off" state
                                    click: () => { // Click event handler for the switch
                                        if ($$('StateSpecialSwith').getValue() == 1) { // Checking if the switch is on
                                            webix
                                                .ajax() // AJAX request to the server
                                                .headers({
                                                    'Content-type': 'application/json', // Setting content type for the request
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint for updating user security
                                                    '{"Action":"StateSpecial","Id":' + cur_user + ',"IsActivate":"A"}', // Request payload
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error handling
                                                            webix.message({
                                                                title: _('¡Error!'), // Error title
                                                                type: 'alert-error', // Error type for styling
                                                                text: _('Ocurrio un error.'), // Error message
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success handling
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StateSpecialSwith').setValue(1); // Setting the switch value
                                                        },
                                                    },
                                                );
                                        } else {
                                            webix
                                                .ajax() // AJAX request to the server
                                                .headers({
                                                    'Content-type': 'application/json', // Setting content type for the request
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint for updating user security
                                                    '{"Action":"StateSpecial","Id":' + cur_user + ',"IsActivate":"I"}', // Request payload
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error handling
                                                            webix.message({
                                                                title: _('¡Error!'), // Error title
                                                                type: 'alert-error', // Error type for styling
                                                                text: _('Ocurrio un error.'), // Error message
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success handling
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StateSpecialSwith').setValue(0); // Setting the switch value
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            ],
                        },
                        {
                            view: 'form', // Form view for contingency sports
                            id: 'ContingencyDeportivas', // Unique identifier for the form
                            hidden: !devConfig.getPermAction('customersSecurityChangesContingenciaDeportivasSwitch', 'Switch'), // Conditional visibility based on permissions
                            css: 'secutity prm-customersSecurityChangesContingenciaDeportivasSwitch', // CSS classes for styling
                            rows: [ // Array of rows in the form
                                {
                                    view: 'label', // Label for the form
                                    label: _('Contingencia Deportivas'), // Text for the label
                                },
                                {
                                    id: 'StateContingencyDeportivasSwith', // Unique identifier for the switch
                                    view: 'switch', // Switch view for toggling contingency sports state
                                    labelWidth: 55, // Width of the label next to the switch
                                    onLabel: _('Activo'), // Label for the "on" state
                                    offLabel: _('Inactivo'), // Label for the "off" state
                                    click: () => { // Click event handler for the switch
                                        if ($$('StateContingencyDeportivasSwith').getValue() == 1) { // Checking if the switch is on
                                            webix
                                                .ajax() // AJAX request to the server
                                                .headers({
                                                    'Content-type': 'application/json', // Setting content type for the request
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint for updating user security
                                                    '{"Action":"ContingencySports","Id":' + cur_user + ',"IsActivate":"A"}', // Request payload
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error handling
                                                            webix.message({
                                                                title: _('¡Error!'), // Error title
                                                                type: 'alert-error', // Error type for styling
                                                                text: _('Ocurrio un error.'), // Error message
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success handling
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StateContingencyDeportivasSwith').setValue(1); // Setting the switch value
                                                        },
                                                    },
                                                );
                                        } else {
                                            webix
                                                .ajax() // AJAX request to the server
                                                .headers({
                                                    'Content-type': 'application/json', // Setting content type for the request
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint for updating user security
                                                    '{"Action":"ContingencySports","Id":' + cur_user + ',"IsActivate":"I"}', // Request payload
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error handling
                                                            webix.message({
                                                                title: _('¡Error!'), // Error title
                                                                type: 'alert-error', // Error type for styling
                                                                text: _('Ocurrio un error.'), // Error message
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success handling
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StateContingencyDeportivasSwith').setValue(0); // Setting the switch value
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            ],
                        },
                    ],
                },
                {
                    margin: 0, // Margin for the layout
                    css: 'on-row', // CSS class for styling
                    id: 'a2', // Unique identifier for this layout
                    cols: [ // Array of columns in the layout
                        {
                            view: 'form', // Form view for contingency casino
                            id: 'ContingencyCasino', // Unique identifier for the form
                            hidden: !devConfig.getPermAction('customersSecurityChangesContingenciaCasinoSwitch', 'Switch'), // Conditional visibility based on permissions
                            css: 'secutity prm-customersSecurityChangesContingenciaCasinoSwitch', // CSS classes for styling
                            rows: [ // Array of rows in the form
                                {
                                    view: 'label', // Label for the form
                                    label: _('Contingencia Casino'), // Text for the label
                                },
                                {
                                    id: 'StateContingencyCasinoSwith', // Unique identifier for the switch
                                    view: 'switch', // Switch view for toggling contingency casino state
                                    labelWidth: 55, // Width of the label next to the switch
                                    onLabel: _('Activo'), // Label for the "on" state
                                    offLabel: _('Inactivo'), // Label for the "off" state
                                    click: () => { // Click event handler for the switch
                                        if ($$('StateContingencyCasinoSwith').getValue() == 1) { // Checking if the switch is on
                                            webix
                                                .ajax() // AJAX request to the server
                                                .headers({
                                                    'Content-type': 'application/json', // Setting content type for the request
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint for updating user security
                                                    '{"Action":"ContingencyCasino","Id":' + cur_user + ',"IsActivate":"A"}', // Request payload
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error handling
                                                            webix.message({
                                                                title: _('¡Error!'), // Error title
                                                                type: 'alert-error', // Error type for styling
                                                                text: _('Ocurrio un error.'), // Error message
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success handling
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StateContingencyCasinoSwith').setValue(1); // Setting the switch value
                                                        },
                                                    },
                                                );
                                        } else {
                                            webix
                                                .ajax() // AJAX request to the server
                                                .headers({
                                                    'Content-type': 'application/json', // Setting content type for the request
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint for updating user security
                                                    '{"Action":"ContingencyCasino","Id":' + cur_user + ',"IsActivate":"I"}', // Request payload
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error handling
                                                            webix.message({
                                                                title: _('¡Error!'), // Error title
                                                                type: 'alert-error', // Error type for styling
                                                                text: _('Ocurrio un error.'), // Error message
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success handling
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StateContingencyCasinoSwith').setValue(0); // Setting the switch value
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            ],
                        },
                        {
                            view: 'form', // Form view for contingency live casino
                            id: 'ContingencyCasinoVivo', // Unique identifier for the form
                            hidden: !devConfig.getPermAction('customersSecurityChangesContingenciaCasinoenVivoSwitch', 'Switch'), // Conditional visibility based on permissions
                            css: 'secutity prm-customersSecurityChangesContingenciaCasinoenVivoSwitch', // CSS classes for styling
                            rows: [ // Array of rows in the form
                                {
                                    view: 'label', // Label for the form
                                    label: _('Contingencia Casino en Vivo'), // Text for the label
                                },
                                {
                                    id: 'StateContingencyCasinoVivoSwith', // Unique identifier for the switch
                                    view: 'switch', // Switch view for toggling contingency live casino state
                                    labelWidth: 55, // Width of the label next to the switch
                                    onLabel: _('Activo'), // Label for the "on" state
                                    offLabel: _('Inactivo'), // Label for the "off" state
                                    click: () => { // Click event handler for the switch
                                        if ($$('StateContingencyCasinoVivoSwith').getValue() == 1) { // Checking if the switch is on
                                            webix
                                                .ajax() // AJAX request to the server
                                                .headers({
                                                    'Content-type': 'application/json', // Setting content type for the request
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint for updating user security
                                                    '{"Action":"ContingencyCasinoVivo","Id":' + cur_user + ',"IsActivate":"A"}', // Request payload
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error handling
                                                            webix.message({
                                                                title: _('¡Error!'), // Error title
                                                                type: 'alert-error', // Error type for styling
                                                                text: _('Ocurrio un error.'), // Error message
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success handling
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StateContingencyCasinoVivoSwith').setValue(1); // Setting the switch value
                                                        },
                                                    },
                                                );
                                        } else {
                                            webix
                                                .ajax() // AJAX request to the server
                                                .headers({
                                                    'Content-type': 'application/json', // Setting content type for the request
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint for updating user security
                                                    '{"Action":"ContingencyCasinoVivo","Id":' + cur_user + ',"IsActivate":"I"}', // Request payload
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error handling
                                                            webix.message({
                                                                title: _('¡Error!'), // Error title
                                                                type: 'alert-error', // Error type for styling
                                                                text: _('Ocurrio un error.'), // Error message
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success handling
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StateContingencyCasinoVivoSwith').setValue(0); // Setting the switch value
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            ],
                        },
                        {
                            view: 'form', // Form view for contingency virtual state
                            id: 'ContingencyVirtuales', // Unique identifier for the form
                            hidden: !devConfig.getPermAction('customersSecurityChangesContingenciaVirtualesSwitch', 'Switch'), // Conditional visibility based on permissions
                            css: 'secutity prm-customersSecurityChangesContingenciaVirtualesSwitch', // CSS classes for styling
                            rows: [ // Array of rows in the form
                                {
                                    view: 'label', // Label for the form
                                    label: _('Estado de Contingencia Virtuales'), // Text for the label
                                },
                                {
                                    id: 'StateContingencyVirtualesSwith', // Unique identifier for the switch
                                    view: 'switch', // Switch view for toggling contingency virtual state
                                    labelWidth: 55, // Width of the label next to the switch
                                    onLabel: _('Activo'), // Label for the "on" state
                                    offLabel: _('Inactivo'), // Label for the "off" state
                                    click: () => { // Click event handler for the switch
                                        if ($$('StateContingencyVirtualesSwith').getValue() == 1) { // Checking if the switch is on
                                            webix
                                                .ajax() // AJAX request to the server
                                                .headers({
                                                    'Content-type': 'application/json', // Setting content type for the request
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint for updating user security
                                                    '{"Action":"ContingencyVirtuales","Id":' + cur_user + ',"IsActivate":"A"}', // Request payload
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error handling
                                                            webix.message('¡Error!'); // Error message
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success handling
                                                            webix.message('Cambios Realizados'); // Success message
                                                            $$('StateContingencyVirtualesSwith').setValue(1); // Setting the switch value
                                                        },
                                                    },
                                                );
                                        } else {
                                            webix
                                                .ajax() // AJAX request to the server
                                                .headers({
                                                    'Content-type': 'application/json', // Setting content type for the request
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint for updating user security
                                                    '{"Action":"ContingencyVirtuales","Id":' + cur_user + ',"IsActivate":"I"}', // Request payload
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error handling
                                                            webix.message({
                                                                title: _('¡Error!'), // Error title
                                                                type: 'alert-error', // Error type for styling
                                                                text: _('Ocurrio un error.'), // Error message
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success handling
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StateContingencyVirtualesSwith').setValue(0); // Setting the switch value
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            ],
                        },
                        {
                            view: 'form', // Form view for contingency poker state
                            id: 'ContingencyPoker', // Unique identifier for the form
                            hidden: !devConfig.getPermAction('customersSecurityChangesContingenciaPokerSwitch', 'Switch'), // Conditional visibility based on permissions
                            css: 'secutity prm-customersSecurityChangesContingenciaPokerSwitch', // CSS classes for styling
                            rows: [ // Array of rows in the form
                                {
                                    view: 'label', // Label for the form
                                    label: _('Estado de Contingencia Poker'), // Text for the label
                                },
                                {
                                    id: 'StateContingencyPokerSwith', // Unique identifier for the switch
                                    view: 'switch', // Switch view for toggling contingency poker state
                                    labelWidth: 55, // Width of the label next to the switch
                                    onLabel: _('Activo'), // Label for the "on" state
                                    offLabel: _('Inactivo'), // Label for the "off" state
                                    click: () => { // Click event handler for the switch
                                        if ($$('StateContingencyPokerSwith').getValue() == 1) { // Checking if the switch is on
                                            webix
                                                .ajax() // AJAX request to the server
                                                .headers({
                                                    'Content-type': 'application/json', // Setting content type for the request
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint for updating user security
                                                    '{"Action":"ContingencyPoker","Id":' + cur_user + ',"IsActivate":"A"}', // Request payload
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error handling
                                                            webix.message({
                                                                title: _('¡Error!'), // Error title
                                                                type: 'alert-error', // Error type for styling
                                                                text: _('Ocurrio un error.'), // Error message
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success handling
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StateContingencyPokerSwith').setValue(1); // Setting the switch value
                                                        },
                                                    },
                                                );
                                        } else {
                                            webix
                                                .ajax() // AJAX request to the server
                                                .headers({
                                                    'Content-type': 'application/json', // Setting content type for the request
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint for updating user security
                                                    '{"Action":"ContingencyPoker","Id":' + cur_user + ',"IsActivate":"I"}', // Request payload
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error handling
                                                            webix.message({
                                                                title: _('¡Error!'), // Error title
                                                                type: 'alert-error', // Error type for styling
                                                                text: _('Ocurrio un error.'), // Error message
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success handling
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StateContingencyPokerSwith').setValue(0); // Setting the switch value
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            ],
                        },
                        {
                            view: 'form', // Form view for advertising preferences
                            id: 'Advertising', // Unique identifier for the form
                            hidden: !devConfig.getPermAction('customersSecurityChangesAdvertisingSwitch', 'Switch'), // Conditional visibility based on permissions
                            css: 'secutity prm-customersSecurityChangesAdvertisingSwitch', // CSS classes for styling
                            rows: [ // Array of rows in the form
                                {
                                    view: 'label', // Label for the form
                                    label: _('Recibir Publicidad'), // Text for the label
                                },
                                {
                                    id: 'StateAdvertisingSwith', // Unique identifier for the switch
                                    view: 'switch', // Switch view for toggling advertising preferences
                                    labelWidth: 55, // Width of the label next to the switch
                                    onLabel: _('Activo'), // Label for the "on" state
                                    offLabel: _('Inactivo'), // Label for the "off" state
                                    click: () => { // Click event handler for the switch
                                        if ($$('StateAdvertisingSwith').getValue() === 1) { // Checking if the switch is on
                                            webix
                                                .ajax() // AJAX request to the server
                                                .headers({
                                                    'Content-type': 'application/json', // Setting content type for the request
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint for updating user security
                                                    '{"Action":"Advertising","Id":' + cur_user + ',"IsActivate":"A"}', // Request payload
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error handling
                                                            webix.message({
                                                                title: _('¡Error!'), // Error title
                                                                type: 'alert-error', // Error type for styling
                                                                text: _('Ocurrio un error.'), // Error message
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success handling
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StateAdvertisingSwith').setValue(1); // Setting the switch value
                                                        },
                                                    },
                                                );
                                        } else {
                                            webix
                                                .ajax() // AJAX request to the server
                                                .headers({
                                                    'Content-type': 'application/json', // Setting content type for the request
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint for updating user security
                                                    '{"Action":"Advertising","Id":' + cur_user + ',"IsActivate":"I"}', // Request payload
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error handling
                                                            webix.message({
                                                                title: _('¡Error!'), // Error title
                                                                type: 'alert-error', // Error type for styling
                                                                text: _('Ocurrio un error.'), // Error message
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success handling
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StateAdvertisingSwith').setValue(0); // Setting the switch value
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            ],
                        },
                    ],
                },
                {
                    margin: 0,
                    css: 'on-row', // CSS class for styling
                    id: 'a3', // Unique identifier for this component
                    cols: [
                        {
                            view: 'form', // Form view for user registration
                            id: 'RegistroUsuario', // Unique identifier for the form
                            hidden: !devConfig.getPermAction('customersSecurityChangesRegistroUserSwitch', 'Switch'), // Visibility based on permission
                            css: 'secutity prm-customersSecurityChangesRegistroUserSwitch', // CSS classes for styling
                            rows: [
                                {
                                    view: 'label', // Label for the switch
                                    label: _('Estado de Registro del Usuario'), // Label text
                                },
                                {
                                    id: 'StateRegistroUsuarioSwith', // Unique identifier for the switch
                                    view: 'switch', // Switch view for user registration state
                                    labelWidth: 55, // Width of the label
                                    onLabel: _('Activo'), // Text for the 'on' state
                                    offLabel: _('Inactivo'), // Text for the 'off' state
                                    click: () => { // Click event handler for the switch
                                        if ($$('StateRegistroUsuarioSwith').getValue() == 1) { // Check if switch is on
                                            webix
                                                .ajax() // AJAX request to update user security
                                                .headers({
                                                    'Content-type': 'application/json', // Set content type
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint
                                                    '{"Action":"RegistroUsuario","Id":' +
                                                    cur_user +
                                                    ',"IsActivate":"A"}', // Request payload for activation
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error callback
                                                            webix.message({
                                                                title: _('¡Error!'), // Error title
                                                                type: 'alert-error', // Error type
                                                                text: _('Ocurrio un error.'), // Error message
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success callback
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StateRegistroUsuarioSwith').setValue(1); // Set switch value to on
                                                        },
                                                    },
                                                );
                                        } else { // If switch is off
                                            webix
                                                .ajax() // AJAX request to update user security
                                                .headers({
                                                    'Content-type': 'application/json', // Set content type
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint
                                                    '{"Action":"RegistroUsuario","Id":' +
                                                    cur_user +
                                                    ',"IsActivate":"I"}', // Request payload for deactivation
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error callback
                                                            webix.message({
                                                                title: _('¡Error!'), // Error title
                                                                type: 'alert-error', // Error type
                                                                text: _('Ocurrio un error.'), // Error message
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success callback
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StateRegistroUsuarioSwith').setValue(0); // Set switch value to off
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            ],
                        },
                        {
                            view: 'form', // Form view for previous DNI verification
                            id: 'DniAnterior', // Unique identifier for the form
                            hidden: !devConfig.getPermAction('customersSecurityChangesVerificoDniAntSwitch', 'Switch'), // Visibility based on permission
                            css: 'secutity prm-customersSecurityChangesVerificoDniAntSwitch', // CSS classes for styling
                            rows: [
                                {
                                    view: 'label', // Label for the switch
                                    label: _('Verificó DNI anterior'), // Label text
                                },
                                {
                                    id: 'StateDniAnterior', // Unique identifier for the switch
                                    view: 'switch', // Switch view for previous DNI verification state
                                    labelWidth: 55, // Width of the label
                                    onLabel: _('Sí'), // Text for the 'on' state
                                    offLabel: _('No'), // Text for the 'off' state
                                    click: () => { // Click event handler for the switch
                                        if ($$('StateDniAnterior').getValue() == 1) { // Check if switch is on
                                            webix
                                                .ajax() // AJAX request to update user security
                                                .headers({
                                                    'Content-type': 'application/json', // Set content type
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint
                                                    '{"Action":"DniAnterior","Id":' + cur_user + ',"IsActivate":"A"}', // Request payload for activation
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error callback
                                                            webix.message({
                                                                title: _('¡Error!'), // Error title
                                                                type: 'alert-error', // Error type
                                                                text: _('Ocurrio un error.'), // Error message
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success callback
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StateDniAnterior').setValue(1); // Set switch value to on
                                                        },
                                                    },
                                                );
                                        } else { // If switch is off
                                            webix
                                                .ajax() // AJAX request to update user security
                                                .headers({
                                                    'Content-type': 'application/json', // Set content type
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint
                                                    '{"Action":"DniAnterior","Id":' + cur_user + ',"IsActivate":"I"}', // Request payload for deactivation
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error callback
                                                            webix.message({
                                                                title: _('¡Error!'), // Error title
                                                                type: 'alert-error', // Error type
                                                                text: _('Ocurrio un error.'), // Error message
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success callback
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StateDniAnterior').setValue(0); // Set switch value to off
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            ],
                        },
                        {
                            view: 'form', // Form view for posterior DNI verification
                            id: 'DniPosterior', // Unique identifier for the form
                            hidden: !devConfig.getPermAction('customersSecurityChangesVerificoDniPostSwitch', 'Switch'), // Visibility based on permission
                            css: 'secutity prm-customersSecurityChangesVerificoDniPostSwitch', // CSS classes for styling
                            rows: [
                                {
                                    view: 'label', // Label for the switch
                                    label: _('Verificó DNI posterior'), // Label text
                                },
                                {
                                    id: 'StateDniPosterior', // Unique identifier for the switch
                                    view: 'switch', // Switch view for posterior DNI verification state
                                    labelWidth: 55, // Width of the label
                                    onLabel: _('Si'), // Text for the 'on' state
                                    offLabel: _('No'), // Text for the 'off' state
                                    click: () => { // Click event handler for the switch
                                        if ($$('StateDniPosterior').getValue() == 1) { // Check if switch is on
                                            webix
                                                .ajax() // AJAX request to update user security
                                                .headers({
                                                    'Content-type': 'application/json', // Set content type
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint
                                                    '{"Action":"DniPosterior","Id":' + cur_user + ',"IsActivate":"A"}', // Request payload for activation
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error callback
                                                            webix.message({
                                                                title: _('¡Error!'), // Error title
                                                                type: 'alert-error', // Error type
                                                                text: _('Ocurrio un error.'), // Error message
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success callback
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StateDniPosterior').setValue(1); // Set switch value to on
                                                        },
                                                    },
                                                );
                                        } else { // If switch is off
                                            webix
                                                .ajax() // AJAX request to update user security
                                                .headers({
                                                    'Content-type': 'application/json', // Set content type
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint
                                                    '{"Action":"DniPosterior","Id":' + cur_user + ',"IsActivate":"I"}', // Request payload for deactivation
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error callback
                                                            webix.message({
                                                                title: _('¡Error!'), // Error title
                                                                type: 'alert-error', // Error type
                                                                text: _('Ocurrio un error.'), // Error message
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success callback
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StateDniPosterior').setValue(0); // Set switch value to off
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            ],
                        },
                        {
                            view: 'form', // Form view for selfie verification
                            id: 'Selfie', // Unique identifier for the form
                            hidden: !devConfig.getPermAction('customersSecurityChangesVerificoSelfie', 'Switch'), // Visibility based on permission
                            css: 'secutity prm-customersSecurityChangesVerificoSelfie', // CSS classes for styling
                            rows: [
                                {
                                    view: 'label', // Label for the switch
                                    label: _('Foto con documento'), // Label text
                                },
                                {
                                    id: 'StateSelfie', // Unique identifier for the switch
                                    view: 'switch', // Switch view for selfie verification state
                                    labelWidth: 55, // Width of the label
                                    onLabel: _('Si'), // Text for the 'on' state
                                    offLabel: _('No'), // Text for the 'off' state
                                    click: () => { // Click event handler for the switch
                                        if ($$('StateSelfie').getValue() == 1) { // Check if switch is on
                                            webix
                                                .ajax() // AJAX request to update user security
                                                .headers({
                                                    'Content-type': 'application/json', // Set content type
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint
                                                    '{"Action":"Selfie","Id":' + cur_user + ',"IsActivate":"A"}', // Request payload for activation
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error callback
                                                            webix.message({
                                                                title: _('¡Error!'), // Error title
                                                                type: 'alert-error', // Error type
                                                                text: _('Ocurrio un error.'), // Error message
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success callback
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StateSelfie').setValue(1); // Set switch value to on
                                                        },
                                                    },
                                                );
                                        } else { // If switch is off
                                            webix
                                                .ajax() // AJAX request to update user security
                                                .headers({
                                                    'Content-type': 'application/json', // Set content type
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint
                                                    '{"Action":"Selfie","Id":' + cur_user + ',"IsActivate":"I"}', // Request payload for deactivation
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error callback
                                                            webix.message({
                                                                title: _('¡Error!'), // Error title
                                                                type: 'alert-error', // Error type
                                                                text: _('Ocurrio un error.'), // Error message
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success callback
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StateSelfie').setValue(0); // Set switch value to off
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            ],
                        },
                        {
                            view: 'form', // Form view for account cancellation
                            id: 'CancelAccount', // Unique identifier for the form
                            hidden: !devConfig.getPermAction('customersSecurityChangesCancelAccountSwitch', 'Switch'), // Visibility based on permission
                            css: 'secutity prm-customersSecurityChangesCancelAccountSwitch', // CSS classes for styling
                            rows: [
                                {
                                    css: 'centrar', // Centering CSS class
                                    id: 'buttonCancelAccount', // Unique identifier for the button
                                    view: 'button', // Button view for account cancellation
                                    labelWidth: 55, // Width of the label
                                    value: _('Cancelar Cuenta'), // Button text
                                    click: () => { // Click event handler for the button
                                        webix.confirm({ // Confirmation dialog for account cancellation
                                            type: 'confirm-warning', // Confirmation type
                                            text:
                                                _('Advertencia!') +
                                                '<br/>' +
                                                _('Desea cancelar la cuenta de el usuario?'), // Confirmation message
                                            ok: _('Cancelar Cuenta'), // Text for the OK button
                                            cancel: _('Salir'), // Text for the Cancel button
                                            callback: function(action) { // Callback for confirmation action
                                                if (action === true) { // If confirmed
                                                    webix
                                                        .ajax() // AJAX request to update user security
                                                        .headers({
                                                            'Content-type': 'application/json', // Set content type
                                                        })
                                                        .post(
                                                            devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint
                                                            '{"Action":"CancelAccount","Id":' +
                                                            cur_user +
                                                            ',"IsActivate":"A"}', // Request payload for account cancellation
                                                            {
                                                                error: function(text, data, XmlHttpRequest) { // Error callback
                                                                    webix.message({
                                                                        title: _('¡Error!'), // Error title
                                                                        type: 'alert-error', // Error type
                                                                        text: _('Ocurrio un error.'), // Error message
                                                                    });
                                                                },
                                                                success: function(text, data, XmlHttpRequest) { // Success callback
                                                                    text = JSON.parse(text); // Parse response text
                                                                    if (text.HasError) { // Check for errors in response
                                                                        webix.message({
                                                                            title: _('¡Error!'), // Error title
                                                                            type: 'alert-error', // Error type
                                                                            text: _('Ocurrio un error.'), // Error message
                                                                        });
                                                                    } else {
                                                                        webix.message(_('Cambios Realizados')); // Success message
                                                                    }
                                                                },
                                                            },
                                                        );
                                                }
                                            },
                                        });
                                    },
                                },
                            ],
                        },
                    ],
                },
                {
                    margin: 0,
                    css: 'on-row', // CSS class for styling
                    id: 'a4', // Unique identifier for this component
                    cols: [
                        {
                            view: 'form', // Form view for contingency withdrawal
                            id: 'ContingencyWithdrawal', // Unique identifier for the form
                            hidden: !devConfig.getPermAction(
                                'customersSecurityChangesContingenciaWithdrawalSwitch',
                                'Switch',
                            ), // Visibility based on permission
                            css: 'secutity prm-customersSecurityChangesContingenciaWithdrawalSwitch', // CSS classes for styling
                            rows: [
                                {
                                    view: 'label', // Label for the switch
                                    label: _('Estado de Contingencia Retiro'), // Label text
                                },
                                {
                                    id: 'StateContingencyWithdrawalSwith', // Unique identifier for the switch
                                    view: 'switch', // Switch view for contingency withdrawal state
                                    labelWidth: 55, // Width of the label
                                    onLabel: _('Activo'), // Text for the 'on' state
                                    offLabel: _('Inactivo'), // Text for the 'off' state
                                    click: () => { // Click event handler for the switch
                                        if ($$('StateContingencyWithdrawalSwith').getValue() == 1) { // Check if switch is on
                                            webix
                                                .ajax() // AJAX request to update user security
                                                .headers({
                                                    'Content-type': 'application/json', // Set content type
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint
                                                    '{"Action":"ContingencyWithdrawal","Id":' +
                                                    cur_user +
                                                    ',"IsActivate":"A"}', // Request payload for activation
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error callback
                                                            webix.message({
                                                                title: _('¡Error!'), // Error title
                                                                type: 'alert-error', // Error type
                                                                text: _('Ocurrio un error.'), // Error message
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success callback
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StateContingencyWithdrawalSwith').setValue(1); // Set switch value to on
                                                        },
                                                    },
                                                );
                                        } else { // If switch is off
                                            webix
                                                .ajax() // AJAX request to update user security
                                                .headers({
                                                    'Content-type': 'application/json', // Set content type
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint
                                                    '{"Action":"ContingencyWithdrawal","Id":' +
                                                    cur_user +
                                                    ',"IsActivate":"I"}', // Request payload for deactivation
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error callback
                                                            webix.message({
                                                                title: _('¡Error!'), // Error title
                                                                type: 'alert-error', // Error type
                                                                text: _('Ocurrio un error.'), // Error message
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success callback
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StateContingencyWithdrawalSwith').setValue(0); // Set switch value to off
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            ],
                        },
                        {
                            view: 'form', // Form view for contingency deposit
                            id: 'ContingencyDeposit', // Unique identifier for the form
                            hidden: !devConfig.getPermAction(
                                'customersSecurityChangesContingenciaDepositSwitch',
                                'Switch',
                            ), // Visibility based on permission
                            css: 'secutity prm-customersSecurityChangesContingenciaDepositSwitch', // CSS classes for styling
                            rows: [
                                {
                                    view: 'label', // Label for the switch
                                    label: _('Estado de Contingencia Depósito'), // Label text
                                },
                                {
                                    id: 'StateContingencyDepositSwith', // Unique identifier for the switch
                                    view: 'switch', // Switch view for contingency deposit state
                                    labelWidth: 55, // Width of the label
                                    onLabel: _('Activo'), // Text for the 'on' state
                                    offLabel: _('Inactivo'), // Text for the 'off' state
                                    click: () => { // Click event handler for the switch
                                        if ($$('StateContingencyDepositSwith').getValue() == 1) { // Check if switch is on
                                            webix
                                                .ajax() // AJAX request to update user security
                                                .headers({
                                                    'Content-type': 'application/json', // Set content type
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint
                                                    '{"Action":"ContingencyDeposit","Id":' +
                                                    cur_user +
                                                    ',"IsActivate":"A"}', // Request payload for activation
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error callback
                                                            webix.message({
                                                                title: _('¡Error!'), // Error title
                                                                type: 'alert-error', // Error type
                                                                text: _('Ocurrio un error.'), // Error message
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success callback
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StateContingencyDepositSwith').setValue(1); // Set switch value to on
                                                        },
                                                    },
                                                );
                                        } else { // If switch is off
                                            webix
                                                .ajax() // AJAX request to update user security
                                                .headers({
                                                    'Content-type': 'application/json', // Set content type
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint
                                                    '{"Action":"ContingencyDeposit","Id":' +
                                                    cur_user +
                                                    ',"IsActivate":"I"}', // Request payload for deactivation
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error callback
                                                            webix.message({
                                                                title: _('¡Error!'), // Error title
                                                                type: 'alert-error', // Error type
                                                                text: _('Ocurrio un error.'), // Error message
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success callback
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StateContingencyDepositSwith').setValue(0); // Set switch value to off
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            ],
                        },
                    ],
                },
                {
                    margin: 0, // Margin for the row
                    css: 'on-row', // CSS class for styling
                    id: 'a5', // Unique identifier for the row
                    cols: [
                        {
                            view: 'form', // Form view for sending SMS
                            id: 'AllowSendSms', // Unique identifier for the form
                            hidden: !devConfig.getPermAction('customersSecurityChangesAllowSendSmsSwitch', 'Switch'), // Visibility based on permissions
                            css: 'secutity prm-customersSecurityChangesAllowSendSmsSwitch', // CSS classes for styling
                            rows: [
                                { view: 'label', label: _('Enviar SMS') }, // Label for the SMS option
                                {
                                    id: 'StateAllowSendSmsSwith', // Unique identifier for the switch
                                    view: 'switch', // Switch view for enabling/disabling SMS
                                    labelWidth: 55, // Width of the label
                                    onLabel: _('Activo'), // Label when switch is on
                                    offLabel: _('Inactivo'), // Label when switch is off
                                    click: () => { // Click event handler for the switch
                                        if ($$('StateAllowSendSmsSwith').getValue() == 1) { // Check if switch is on
                                            webix
                                                .ajax() // AJAX request to update user security
                                                .headers({
                                                    'Content-type': 'application/json', // Set content type to JSON
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint
                                                    '{"Action":"AllowSendSms","Id":' + cur_user + ',"IsActivate":"A"}', // Request payload
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error callback
                                                            webix.message({
                                                                title: _('¡Error!'), // Error message title
                                                                type: 'alert-error', // Error message type
                                                                text: _('Ocurrio un error.'), // Error message text
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success callback
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StateAllowSendSmsSwith').setValue(1); // Set switch value to on
                                                        },
                                                    },
                                                );
                                        } else {
                                            webix
                                                .ajax() // AJAX request to update user security
                                                .headers({
                                                    'Content-type': 'application/json', // Set content type to JSON
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint
                                                    '{"Action":"AllowSendSms","Id":' + cur_user + ',"IsActivate":"I"}', // Request payload
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error callback
                                                            webix.message({
                                                                title: _('¡Error!'), // Error message title
                                                                type: 'alert-error', // Error message type
                                                                text: _('Ocurrio un error.'), // Error message text
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success callback
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StateAllowSendSmsSwith').setValue(0); // Set switch value to off
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            ],
                        },
                        {
                            view: 'form', // Form view for sending Email
                            id: 'AllowSendEmail', // Unique identifier for the form
                            hidden: !devConfig.getPermAction('customersSecurityChangesAllowSendEmailSwitch', 'Switch'), // Visibility based on permissions
                            css: 'secutity prm-customersSecurityChangesAllowSendEmailSwitch', // CSS classes for styling
                            rows: [
                                { view: 'label', label: _('Enviar Email') }, // Label for the Email option
                                {
                                    id: 'StateAllowSendEmailSwith', // Unique identifier for the switch
                                    view: 'switch', // Switch view for enabling/disabling Email
                                    labelWidth: 55, // Width of the label
                                    onLabel: _('Activo'), // Label when switch is on
                                    offLabel: _('Inactivo'), // Label when switch is off
                                    click: () => { // Click event handler for the switch
                                        if ($$('StateAllowSendEmailSwith').getValue() == 1) { // Check if switch is on
                                            webix
                                                .ajax() // AJAX request to update user security
                                                .headers({
                                                    'Content-type': 'application/json', // Set content type to JSON
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint
                                                    '{"Action":"AllowSendEmail","Id":' +
                                                    cur_user +
                                                    ',"IsActivate":"A"}', // Request payload
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error callback
                                                            webix.message({
                                                                title: _('¡Error!'), // Error message title
                                                                type: 'alert-error', // Error message type
                                                                text: _('Ocurrio un error.'), // Error message text
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success callback
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StateAllowSendEmailSwith').setValue(1); // Set switch value to on
                                                        },
                                                    },
                                                );
                                        } else {
                                            webix
                                                .ajax() // AJAX request to update user security
                                                .headers({
                                                    'Content-type': 'application/json', // Set content type to JSON
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint
                                                    '{"Action":"AllowSendEmail","Id":' +
                                                    cur_user +
                                                    ',"IsActivate":"I"}', // Request payload
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error callback
                                                            webix.message({
                                                                title: _('¡Error!'), // Error message title
                                                                type: 'alert-error', // Error message type
                                                                text: _('Ocurrio un error.'), // Error message text
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success callback
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StateAllowSendEmailSwith').setValue(0); // Set switch value to off
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            ],
                        },
                        {
                            view: 'form', // Form view for sending Phone notifications
                            id: 'AllowSendPhone', // Unique identifier for the form
                            hidden: !devConfig.getPermAction('customersSecurityChangesAllowSendPhoneSwitch', 'Switch'), // Visibility based on permissions
                            css: 'secutity prm-customersSecurityChangesAllowSendPhoneSwitch', // CSS classes for styling
                            rows: [
                                { view: 'label', label: _('Enviar Celular') }, // Label for the Phone option
                                {
                                    id: 'StateAllowSendPhoneSwith', // Unique identifier for the switch
                                    view: 'switch', // Switch view for enabling/disabling Phone notifications
                                    labelWidth: 55, // Width of the label
                                    onLabel: _('Activo'), // Label when switch is on
                                    offLabel: _('Inactivo'), // Label when switch is off
                                    click: () => { // Click event handler for the switch
                                        if ($$('StateAllowSendPhoneSwith').getValue() == 1) { // Check if switch is on
                                            webix
                                                .ajax() // AJAX request to update user security
                                                .headers({
                                                    'Content-type': 'application/json', // Set content type to JSON
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint
                                                    '{"Action":"AllowSendPhone","Id":' +
                                                    cur_user +
                                                    ',"IsActivate":"A"}', // Request payload
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error callback
                                                            webix.message({
                                                                title: _('¡Error!'), // Error message title
                                                                type: 'alert-error', // Error message type
                                                                text: _('Ocurrio un error.'), // Error message text
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success callback
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StateAllowSendPhoneSwith').setValue(1); // Set switch value to on
                                                        },
                                                    },
                                                );
                                        } else {
                                            webix
                                                .ajax() // AJAX request to update user security
                                                .headers({
                                                    'Content-type': 'application/json', // Set content type to JSON
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint
                                                    '{"Action":"AllowSendPhone","Id":' +
                                                    cur_user +
                                                    ',"IsActivate":"I"}', // Request payload
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error callback
                                                            webix.message({
                                                                title: _('¡Error!'), // Error message title
                                                                type: 'alert-error', // Error message type
                                                                text: _('Ocurrio un error.'), // Error message text
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success callback
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StateAllowSendPhoneSwith').setValue(0); // Set switch value to off
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            ],
                        },
                        {
                            view: 'form', // Form view for sending Push notifications
                            id: 'AllowSendPush', // Unique identifier for the form
                            hidden: !devConfig.getPermAction('customersSecurityChangesAllowSendPushSwitch', 'Switch'), // Visibility based on permissions
                            css: 'secutity prm-customersSecurityChangesAllowSendPushSwitch', // CSS classes for styling
                            rows: [
                                {
                                    view: 'label', // Label for the Push notifications option
                                    label: _('Enviar Notificaciones Push'),
                                },
                                {
                                    id: 'StateAllowSendPushSwith', // Unique identifier for the switch
                                    view: 'switch', // Switch view for enabling/disabling Push notifications
                                    labelWidth: 55, // Width of the label
                                    onLabel: _('Activo'), // Label when switch is on
                                    offLabel: _('Inactivo'), // Label when switch is off
                                    click: () => { // Click event handler for the switch
                                        if ($$('StateAllowSendPushSwith').getValue() == 1) { // Check if switch is on
                                            webix
                                                .ajax() // AJAX request to update user security
                                                .headers({
                                                    'Content-type': 'application/json', // Set content type to JSON
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint
                                                    '{"Action":"AllowSendPush","Id":' + cur_user + ',"IsActivate":"A"}', // Request payload
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error callback
                                                            webix.message({
                                                                title: _('¡Error!'), // Error message title
                                                                type: 'alert-error', // Error message type
                                                                text: _('Ocurrio un error.'), // Error message text
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success callback
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StateAllowSendPushSwith').setValue(1); // Set switch value to on
                                                        },
                                                    },
                                                );
                                        } else {
                                            webix
                                                .ajax() // AJAX request to update user security
                                                .headers({
                                                    'Content-type': 'application/json', // Set content type to JSON
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint
                                                    '{"Action":"AllowSendPush","Id":' + cur_user + ',"IsActivate":"I"}', // Request payload
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error callback
                                                            webix.message({
                                                                title: _('¡Error!'), // Error message title
                                                                type: 'alert-error', // Error message type
                                                                text: _('Ocurrio un error.'), // Error message text
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success callback
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StateAllowSendPushSwith').setValue(0); // Set switch value to off
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            ],
                        },
                        {
                            view: 'form', // Form view for managing abuse of bonuses
                            id: 'AbusadorBonos', // Unique identifier for the form
                            hidden: !devConfig.getPermAction(
                                'customersSecurityChangesBonosAbusadorAntSwitch',
                                'Switch',
                            ), // Visibility based on permissions
                            css: 'secutity prm-customersSecurityChangesBonosAbusadorAntSwitch', // CSS classes for styling
                            rows: [
                                {
                                    view: 'label', // Label for the abuse of bonuses option
                                    label: _('Abusador de Bonos'),
                                },
                                {
                                    id: 'StateAbusadorBonos', // Unique identifier for the switch
                                    view: 'switch', // Switch view for enabling/disabling abuse of bonuses
                                    labelWidth: 55, // Width of the label
                                    onLabel: _('Sí'), // Label when switch is on
                                    offLabel: _('No'), // Label when switch is off
                                    click: () => { // Click event handler for the switch
                                        if ($$('StateAbusadorBonos').getValue() == 1) { // Check if switch is on
                                            webix
                                                .ajax() // AJAX request to update user security
                                                .headers({
                                                    'Content-type': 'application/json', // Set content type to JSON
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint
                                                    '{"Action":"AbusadorBonos","Id":' + cur_user + ',"IsActivate":"A"}', // Request payload
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error callback
                                                            webix.message({
                                                                title: _('¡Error!'), // Error message title
                                                                type: 'alert-error', // Error message type
                                                                text: _('Ocurrio un error.'), // Error message text
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success callback
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StateAbusadorBonos').setValue(1); // Set switch value to on
                                                        },
                                                    },
                                                );
                                        } else {
                                            webix
                                                .ajax() // AJAX request to update user security
                                                .headers({
                                                    'Content-type': 'application/json', // Set content type to JSON
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint
                                                    '{"Action":"AbusadorBonos","Id":' + cur_user + ',"IsActivate":"I"}', // Request payload
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error callback
                                                            webix.message({
                                                                title: _('¡Error!'), // Error message title
                                                                type: 'alert-error', // Error message type
                                                                text: _('Ocurrio un error.'), // Error message text
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success callback
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StateAbusadorBonos').setValue(0); // Set switch value to off
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            ],
                        },
                    ],
                },
                {
                    margin: 0, // Margin for the row
                    css: 'on-row', // CSS class for styling
                    id: 'a6', // Unique identifier for the row
                    cols: [
                        send_code_mobile, // Reference to a mobile code sending component
                        {
                            view: 'form', // Form view for phone verification
                            id: 'PhoneVerification', // Unique identifier for the form
                            hidden: !devConfig.getPermAction(
                                'customersSecurityChangesPhoneVerificationSwitch',
                                'Switch',
                            ), // Visibility based on permissions
                            css: 'secutity prm-customersSecurityChangesPhoneVerificationSwitch', // CSS classes for styling
                            rows: [
                                { view: 'label', label: _('Verificó Celular') }, // Label for the phone verification option
                                {
                                    id: 'StatePhoneVerification', // Unique identifier for the switch
                                    view: 'switch', // Switch view for enabling/disabling phone verification
                                    labelWidth: 55, // Width of the label
                                    onLabel: _('Si'), // Label when switch is on
                                    offLabel: _('No'), // Label when switch is off
                                    click: () => { // Click event handler for the switch
                                        if ($$('StatePhoneVerification').getValue() === 1) { // Check if switch is on
                                            webix
                                                .ajax() // AJAX request to update user security
                                                .headers({
                                                    'Content-type': 'application/json', // Set content type to JSON
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint
                                                    '{"Action":"PhoneVerification","Id":' +
                                                    cur_user +
                                                    ',"IsActivate":"A"}', // Request payload
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error callback
                                                            webix.message({
                                                                title: _('¡Error!'), // Error message title
                                                                type: 'alert-error', // Error message type
                                                                text: _('Ocurrio un error.'), // Error message text
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success callback
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StatePhoneVerification').setValue(1); // Set switch value to on
                                                        },
                                                    },
                                                );
                                        } else {
                                            webix
                                                .ajax() // AJAX request to update user security
                                                .headers({
                                                    'Content-type': 'application/json', // Set content type to JSON
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint
                                                    '{"Action":"PhoneVerification","Id":' +
                                                    cur_user +
                                                    ',"IsActivate":"I"}', // Request payload
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error callback
                                                            webix.message({
                                                                title: _('¡Error!'), // Error message title
                                                                type: 'alert-error', // Error message type
                                                                text: _('Ocurrio un error.'), // Error message text
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success callback
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StatePhoneVerification').setValue(0); // Set switch value to off
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            ],
                        },
                        {
                            view: 'form', // Form view for contingency retail withdrawals
                            id: 'ContingencyRetailWithdrawals', // Unique identifier for the form
                            hidden: !devConfig.getPermAction(
                                "customersSecurityChangesContingenciaRetirosRetailSwitch",
                                "Switch",
                            ), // Visibility based on permissions
                            css: "secutity prm-customersSecurityChangesContingenciaRetirosRetailSwitch", // CSS classes for styling
                            rows: [
                                { view: "label", label: _("Contingencia Retail") }, // Label for the contingency retail withdrawals option
                                {
                                    id: "StateContingencyRetailWithdrawalsSwith", // Unique identifier for the switch
                                    view: "switch", // Switch view for enabling/disabling contingency retail withdrawals
                                    labelWidth: 55, // Width of the label
                                    onLabel: _("Activo"), // Label when switch is on
                                    offLabel: _("Inactivo"), // Label when switch is off
                                    click: () => { // Click event handler for the switch
                                        if ($$("StateContingencyRetailWithdrawalsSwith").getValue() == 1) { // Check if switch is on
                                            webix
                                                .ajax() // AJAX request to update user security
                                                .headers({
                                                    "Content-type": "application/json", // Set content type to JSON
                                                })
                                                .post(
                                                    devConfig.geturlApi() + "Client/UpdateUserSecurity", // API endpoint
                                                    '{"Action":"ContingencyRetailWithdrawals","Id":' +
                                                    cur_user +
                                                    ',"IsActivate":"A"}', // Request payload
                                                    {
                                                        error: function (text, data, XmlHttpRequest) { // Error callback
                                                            webix.message({
                                                                title: _("¡Error!"), // Error message title
                                                                type: "alert-error", // Error message type
                                                                text: _("Ocurrio un error."), // Error message text
                                                            });
                                                        },
                                                        success: function (text, data, XmlHttpRequest) { // Success callback
                                                            webix.message(_("Cambios Realizados")); // Success message
                                                            $$("StateContingencyRetailWithdrawalsSwith").setValue(1); // Set switch value to on
                                                        },
                                                    },
                                                );
                                        } else {
                                            webix
                                                .ajax() // AJAX request to update user security
                                                .headers({
                                                    "Content-type": "application/json", // Set content type to JSON
                                                })
                                                .post(
                                                    devConfig.geturlApi() + "Client/UpdateUserSecurity", // API endpoint
                                                    '{"Action":"ContingencyRetailWithdrawals","Id":' +
                                                    cur_user +
                                                    ',"IsActivate":"I"}', // Request payload
                                                    {
                                                        error: function (text, data, XmlHttpRequest) { // Error callback
                                                            webix.message({
                                                                title: _("¡Error!"), // Error message title
                                                                type: "alert-error", // Error message type
                                                                text: _("Ocurrio un error."), // Error message text
                                                            });
                                                        },
                                                        success: function (text, data, XmlHttpRequest) { // Success callback
                                                            webix.message(_("Cambios Realizados")); // Success message
                                                            $$("StateContingencyRetailWithdrawalsSwith").setValue(0); // Set switch value to off
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            ],
                        },
                        {
                            view: 'form', // Form view for point-of-sale deposit contingency
                            id: 'PointOfSaleContingency', // Unique identifier for the form
                            hidden: !devConfig.getPermAction(
                                "customersSecurityChangesContingenciaDepositosRetailSwitch",
                                "Switch",
                            ), // Visibility based on permissions
                            css: "secutity prm-customersSecurityChangesContingenciaDepositosRetailSwitch", // CSS classes for styling
                            rows: [
                                { view: "label", label: _("Contingencia Depositos Retail") }, // Label for the point-of-sale contingency option
                                {
                                    id: "StatePointOfSaleContingencySwith", // Unique identifier for the switch
                                    view: "switch", // Switch view for enabling/disabling point-of-sale contingency
                                    labelWidth: 55, // Width of the label
                                    onLabel: _("Activo"), // Label when switch is on
                                    offLabel: _("Inactivo"), // Label when switch is off
                                    click: () => { // Click event handler for the switch
                                        if ($$("StatePointOfSaleContingencySwith").getValue() == 1) { // Check if switch is on
                                            webix
                                                .ajax() // AJAX request to update user security
                                                .headers({
                                                    "Content-type": "application/json", // Set content type to JSON
                                                })
                                                .post(
                                                    devConfig.geturlApi() + "Client/UpdateUserSecurity", // API endpoint
                                                    '{"Action":"PointOfSaleContingency","Id":' +
                                                    cur_user +
                                                    ',"IsActivate":"A"}', // Request payload
                                                    {
                                                        error: function (text, data, XmlHttpRequest) { // Error callback
                                                            webix.message({
                                                                title: _("¡Error!"), // Error message title
                                                                type: "alert-error", // Error message type
                                                                text: _("Ocurrio un error."), // Error message text
                                                            });
                                                        },
                                                        success: function (text, data, XmlHttpRequest) { // Success callback
                                                            webix.message(_("Cambios Realizados")); // Success message
                                                            $$("StatePointOfSaleContingencySwith").setValue(1); // Set switch value to on
                                                        },
                                                    },
                                                );
                                        } else {
                                            webix
                                                .ajax() // AJAX request to update user security
                                                .headers({
                                                    "Content-type": "application/json", // Set content type to JSON
                                                })
                                                .post(
                                                    devConfig.geturlApi() + "Client/UpdateUserSecurity", // API endpoint
                                                    '{"Action":"PointOfSaleContingency","Id":' +
                                                    cur_user +
                                                    ',"IsActivate":"I"}', // Request payload
                                                    {
                                                        error: function (text, data, XmlHttpRequest) { // Error callback
                                                            webix.message({
                                                                title: _("¡Error!"), // Error message title
                                                                type: "alert-error", // Error message type
                                                                text: _("Ocurrio un error."), // Error message text
                                                            });
                                                        },
                                                        success: function (text, data, XmlHttpRequest) { // Success callback
                                                            webix.message(_("Cambios Realizados")); // Success message
                                                            $$("StatePointOfSaleContingencySwith").setValue(0); // Set switch value to off
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            ],
                        },
                        {
                            view: 'form', // Form view for payment gateway deposit contingency
                            id: 'PaymentGatewayContingency', // Unique identifier for the form
                            hidden: !devConfig.getPermAction(
                                "customersSecurityChangesContingenciaDepositosPasarelasSwitch",
                                "Switch",
                            ), // Visibility based on permissions
                            css: "secutity prm-customersSecurityChangesContingenciaDepositosPasarelasSwitch", // CSS classes for styling
                            rows: [
                                { view: "label", label: _("Contingencia Depósitos Pasarelas") }, // Label for the payment gateway contingency option
                                {
                                    id: "StatePaymentGatewayContingencySwith", // Unique identifier for the switch
                                    view: "switch", // Switch view for enabling/disabling payment gateway contingency
                                    labelWidth: 55, // Width of the label
                                    onLabel: _("Activo"), // Label when switch is on
                                    offLabel: _("Inactivo"), // Label when switch is off
                                    click: () => { // Click event handler for the switch
                                        if ($$("StatePaymentGatewayContingencySwith").getValue() == 1) { // Check if switch is on
                                            webix
                                                .ajax() // AJAX request to update user security
                                                .headers({
                                                    "Content-type": "application/json", // Set content type to JSON
                                                })
                                                .post(
                                                    devConfig.geturlApi() + "Client/UpdateUserSecurity", // API endpoint
                                                    '{"Action":"PaymentGatewayContingency","Id":' +
                                                    cur_user +
                                                    ',"IsActivate":"A"}', // Request payload
                                                    {
                                                        error: function (text, data, XmlHttpRequest) { // Error callback
                                                            webix.message({
                                                                title: _("¡Error!"), // Error message title
                                                                type: "alert-error", // Error message type
                                                                text: _("Ocurrio un error."), // Error message text
                                                            });
                                                        },
                                                        success: function (text, data, XmlHttpRequest) { // Success callback
                                                            webix.message(_("Cambios Realizados")); // Success message
                                                            $$("StatePaymentGatewayContingencySwith").setValue(1); // Set switch value to on
                                                        },
                                                    },
                                                );
                                        } else {
                                            webix
                                                .ajax() // AJAX request to update user security
                                                .headers({
                                                    "Content-type": "application/json", // Set content type to JSON
                                                })
                                                .post(
                                                    devConfig.geturlApi() + "Client/UpdateUserSecurity", // API endpoint
                                                    '{"Action":"PaymentGatewayContingency","Id":' +
                                                    cur_user +
                                                    ',"IsActivate":"I"}', // Request payload
                                                    {
                                                        error: function (text, data, XmlHttpRequest) { // Error callback
                                                            webix.message({
                                                                title: _("¡Error!"), // Error message title
                                                                type: "alert-error", // Error message type
                                                                text: _("Ocurrio un error."), // Error message text
                                                            });
                                                        },
                                                        success: function (text, data, XmlHttpRequest) { // Success callback
                                                            webix.message(_("Cambios Realizados")); // Success message
                                                            $$("StatePaymentGatewayContingencySwith").setValue(0); // Set switch value to off
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            ],
                        },
                        {
                            view: 'form', // Form view for phone verification
                            id: '2AFUser', // Unique identifier for the form
                            hidden: !devConfig.getPermAction(
                                '2AFUserSwitch',
                                'Switch',
                            ), // Visibility based on permissions
                            css: 'secutity prm-customersSecurityChangesPhoneVerificationSwitch', // CSS classes for styling
                            rows: [
                                { view: 'label', label: _('Doble Factor De Autenticación') }, // Label for the phone verification option
                                {
                                    id: 'Active2FAUsersOnline', // Unique identifier for the switch
                                    view: 'switch', // Switch view for enabling/disabling phone verification
                                    labelWidth: 55, // Width of the label
                                    onLabel: _('Activo'), // Label when switch is on
                                    offLabel: _('Inactivo'), // Label when switch is off
                                    click: () => { // Click event handler for the switch
                                        if ($$('Active2FAUsersOnline').getValue() === 1) { // Check if switch is on
                                            webix
                                                .ajax() // AJAX request to update user security
                                                .headers({
                                                    'Content-type': 'application/json', // Set content type to JSON
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint
                                                    '{"Action":"Active2FAUsersOnline","Id":' +
                                                    cur_user +
                                                    ',"IsActivate":"A"}', // Request payload
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error callback
                                                            webix.message({
                                                                title: _('¡Error!'), // Error message title
                                                                type: 'alert-error', // Error message type
                                                                text: _('Ocurrio un error.'), // Error message text
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success callback
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StatePhoneVerification').setValue(1); // Set switch value to on
                                                        },
                                                    },
                                                );
                                        } else {
                                            webix
                                                .ajax() // AJAX request to update user security
                                                .headers({
                                                    'Content-type': 'application/json', // Set content type to JSON
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint
                                                    '{"Action":"Active2FAUsersOnline","Id":' +
                                                    cur_user +
                                                    ',"IsActivate":"I"}', // Request payload
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error callback
                                                            webix.message({
                                                                title: _('¡Error!'), // Error message title
                                                                type: 'alert-error', // Error message type
                                                                text: _('Ocurrio un error.'), // Error message text
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success callback
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StatePhoneVerification').setValue(0); // Set switch value to off
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            ],
                        },
                        {
                            view: "form", // Defines a Webix form component
                            id: "StradacarteRegister", // Unique ID for the form
                            width: 280, // Sets the form width to 280px
                            css: "secutity prm-customersSecurityStradacarteRegisterSwitch", // Custom CSS classes for styling
                            hidden: !(
                                devConfig.getPermAction("customersSecurityStradacarteRegisterLabel", "Switch") ||
                                devConfig.getPermAction("customersSecurityStradacarteRegisterButton", "Switch")
                            ), // The form will be hidden unless the user has permission to see either the label or the button
                            rows: [
                                {
                                    view: "label", // A Webix label element
                                    id: "StradacarteStatusLabel", // ID for updating the label later
                                    label: _("Registrado en Stradacarte"), // Initial text for the label (translated)
                                    hidden: !devConfig.getPermAction("customersSecurityStradacarteRegisterLabel", "Switch"), // Hidden if the user lacks permission to view the label
                                },
                                {
                                    id: "StradacarteRegisterBtn", // ID for the registration button
                                    view: "button", // Defines a Webix button
                                    css: "webix_primary", // Primary button styling
                                    value: _("Registrar en Stradacarte"), // Button label (translated)
                                    hidden: !devConfig.getPermAction("customersSecurityStradacarteRegisterButton", "Switch"), // Hidden if the user lacks permission to view the button
                                    click: () => { // Click event handler for the button
                                        const btn = $$("StradacarteRegisterBtn"); // Get a reference to the register button
                                        btn.disable(); // Disable button to prevent multiple clicks
                                        btn.setValue(_("Procesando...")); // Change button text to "Processing..."

                                        webix.ajax() // Start Webix AJAX request
                                            .headers({ "Content-type": "application/json" }) // Set request header to JSON
                                            .post(
                                                devConfig.geturlApi() + "Client/RegisterStradacarte", // API endpoint for Stradacarte registration
                                                JSON.stringify({ Id: cur_user }), // Payload: send the current user ID
                                                {
                                                    error: function (text, data, XmlHttpRequest) { // Callback executed on HTTP/network error
                                                        webix.message({
                                                            title: _("¡Error!"), // Error title message
                                                            type: "alert-error", // Show red error style
                                                            text: _("Ocurrio un error."), // Generic error text
                                                        });
                                                        btn.enable(); // Re-enable the button
                                                        btn.setValue(_("Registrar en Stradacarte")); // Restore the button text
                                                    },

                                                    success: function (resp) { // Callback executed when request succeeds (HTTP 200)
                                                        try {
                                                            const parsed = JSON.parse(resp); // Attempt to parse backend response as JSON

                                                            if (parsed.HasError === true) { // If backend indicates logical error
                                                                btn.enable(); // Re-enable the button
                                                                btn.setValue(_("Registrar en Stradacarte")); // Restore button text

                                                                return this.error(resp); // Trigger Webix error callback manually
                                                            }
                                                        } catch (e) {
                                                            // If JSON parsing fails, treat it as an error
                                                            btn.enable(); // Re-enable the button
                                                            btn.setValue(_("Registrar en Stradacarte")); // Restore button text

                                                            return this.error(resp); // Trigger error callback
                                                        }

                                                        webix.message(_("Registro exitoso. El correo de validación ha sido enviado al jugador."));
                                                        // Show success message when backend reports success

                                                        webix.ajax().get(devConfig.geturlApi() + "Client/GetClientById", "id=" + cur_user, {
                                                            success: function (resp) { // Callback for retrieving updated user data
                                                                resp = JSON.parse(resp); // Parse the response JSON
                                                                const estado = resp[0].RegisteredStradacarte; // Get Stradacarte registration status

                                                                if (estado === "S") { // If registered (value "S")
                                                                    $$("StradacarteStatusLabel").setHTML("Registrado en Stradacarte: <b>Sí</b>");
                                                                    // Update label to show "Yes"
                                                                    btn.disable(); // Disable button again since the user is already registered
                                                                } else {
                                                                    $$("StradacarteStatusLabel").setHTML("Registrado en Stradacarte: <b>No</b>");
                                                                    // Update label to show "No"
                                                                    btn.enable(); // Re-enable the button
                                                                    btn.setValue(_("Registrar en Stradacarte")); // Restore button text
                                                                }
                                                            },

                                                            error: function () { // Callback executed if GetClientById fails
                                                                webix.message({
                                                                    title: _("¡Error!"), // Error title
                                                                    type: "alert-error", // Error styling
                                                                    text: _("El registro fue exitoso pero no se pudo actualizar el estado."),
                                                                    // Error message when update fails
                                                                });
                                                                btn.enable(); // Re-enable the button
                                                                btn.setValue(_("Registrar en Stradacarte")); // Restore button text
                                                            }
                                                        });
                                                    },
                                                }
                                            );
                                    }
                                },
                            ],
                        },
                        {},
                    ],
                },
            ],
        };

        // Define the upper_section object to configure the layout of the form
        const upper_section = {
            // Set height based on the width of the document body
            height: document.body.offsetWidth < 500 ? 1110 : 0,
            // Define CSS classes for styling
            css: 'secutity prm-',
            // Define rows within the upper section
            rows: [
                {
                    // Set margin for the row
                    margin: 10,
                    // Define columns within the row, with 'left' presumably being a predefined variable
                    cols: [left],
                },
            ],
        };

        // Return the configuration object for the form
        return {
            // Specify the type of view
            view: 'form',
            // Assign a unique identifier to the form
            id: 'myForm',
            // Include the upper_section in the form's rows
            rows: [upper_section],
            // Define validation rules for form fields
            rules: {
                // Ensure the 'fname' field is not empty
                fname: webix.rules.isNotEmpty,
            },
        }; // Placeholder for the configuration content
    }

    /**
     * Initializes the view and its components.
     * @param {Object} grid - The grid component to be initialized.
     */
    init(grid) {
        webix.ready(function() {
            // Retrieve the height of various elements identified by their IDs
            var ancho1 = $$('a1').$height;
            var ancho2 = $$('a2').$height;
            var ancho3 = $$('a3').$height;
            var ancho4 = $$('a4').$height;
            var ancho5 = $$('a5').$height;

            // Hide elements if their height is less than 100
            if (ancho1 < 100) {
                $$('a1').hide();
            }
            console.log(ancho2);
            if (ancho2 < 100) {
                $$('a2').hide();
            }
            if (ancho3 < 100) {
                $$('a3').hide();
            }
            if (ancho4 < 100) {
                $$('a4').hide();
            }
            if (ancho5 < 100) {
                $$('a5').hide();
            }
        });

        // Get the current user parameter from the URL
        const cur_user = this.getParam('user', true);

        // Add custom CSS styles for background colors
        webix.html.addStyle('.bkgRed{ background:rgba(255, 0, 0, 0.5803921568627451) !important; }');
        webix.html.addStyle('.bkgGreen{ background:rgba(3, 199, 3, 0.35) !important; }');

        // Make an AJAX GET request to fetch client data by ID
        webix.ajax().get(devConfig.geturlApi() + 'Client/GetClientById', 'id=' + cur_user, {
            // Handle error response
            error: function(text, data, XmlHttpRequest) {
                webix.message({
                    title: _('¡Error!'),
                    type: 'alert-error',
                    text: _('Ocurrio un error.'),
                });
            },
            // Handle successful response
            success: function(text, data, XmlHttpRequest) {
                text = JSON.parse(text); // Parse the JSON response

                // Set the value of various switches based on the activation status from the response
                if (text[0].IsActivate == 'A') {
                    $$('StateSwith').setValue(1);
                } else {
                    $$('StateSwith').setValue(0);
                }
                if (text[0].IsActivateContingency == 'A') {
                    $$('StateContingencySwith').setValue(1);
                } else {
                    $$('StateContingencySwith').setValue(0);
                }
                if (text[0].IsActivateSpecial == 'A') {
                    $$('StateSpecialSwith').setValue(1);
                } else {
                    $$('StateSpecialSwith').setValue(0);
                }
                if (text[0].IsActivateContingencyDeportivas == 'A') {
                    $$('StateContingencyDeportivasSwith').setValue(1);
                } else {
                    $$('StateContingencyDeportivasSwith').setValue(0);
                }
                if (text[0].IsActivateContingencyCasino == 'A') {
                    $$('StateContingencyCasinoSwith').setValue(1);
                } else {
                    $$('StateContingencyCasinoSwith').setValue(0);
                }
                if (text[0].IsActivateContingencyCasinoVivo == 'A') {
                    $$('StateContingencyCasinoVivoSwith').setValue(1);
                } else {
                    $$('StateContingencyCasinoVivoSwith').setValue(0);
                }
                if (text[0].IsActivateContingencyRetirosRetail == "A") {
                    $$("StateContingencyRetailWithdrawalsSwith").setValue(1);
                } else {
                    $$("StateContingencyRetailWithdrawalsSwith").setValue(0);
                }
                if (text[0].IsActivateContingencyVirtuales == 'A') {
                    $$('StateContingencyVirtualesSwith').setValue(1);
                } else {
                    $$('StateContingencyVirtualesSwith').setValue(0);
                }
                if (text[0].IsActivateContingencyPoker == 'A') {
                    $$('StateContingencyPokerSwith').setValue(1);
                } else {
                    $$('StateContingencyPokerSwith').setValue(0);
                }
                if (text[0].IsActivateRegistroUsuario == 'A') {
                    $$('StateRegistroUsuarioSwith').setValue(1);
                } else {
                    $$('StateRegistroUsuarioSwith').setValue(0);
                }
                if (text[0].IsActivateDniAnterior == 'A') {
                    $$('StateDniAnterior').setValue(1);
                } else {
                    $$('StateDniAnterior').setValue(0);
                }
                if (text[0].IsActivateAbusadorBonos == 'A') {
                    $$('StateAbusadorBonos').setValue(1);
                } else {
                    $$('StateAbusadorBonos').setValue(0);
                }
                if (text[0].IsActivateDniPosterior == 'A') {
                    $$('StateDniPosterior').setValue(1);
                } else {
                    $$('StateDniPosterior').setValue(0);
                }
                if (text[0].IsActivatePhoneVerification == 'A') {
                    $$('StatePhoneVerification').setValue(1);
                } else {
                    $$('StatePhoneVerification').setValue(0);
                }
                if (text[0].IsActivateSelfie == 'A') {
                    $$('StateSelfie').setValue(1);
                } else {
                    $$('StateSelfie').setValue(0);
                }
                if (text[0].IsActivateContingencyWithdrawal == 'A') {
                    $$('StateContingencyWithdrawalSwith').setValue(1);
                } else {
                    $$('StateContingencyWithdrawalSwith').setValue(0);
                }
                if (text[0].IsActivateContingencyDeposit == 'A') {
                    $$('StateContingencyDepositSwith').setValue(1);
                } else {
                    $$('StateContingencyDepositSwith').setValue(0);
                }
                if (text[0].IsActivateContingencyDepositRetail == 'A') {
                    $$('StatePointOfSaleContingencySwith').setValue(1);
                } else {
                    $$('StatePointOfSaleContingencySwith').setValue(0);
                }
                if (text[0].IsActivateContingencyDepositUsuOnline == 'A') {
                    $$('StatePaymentGatewayContingencySwith').setValue(1);
                } else {
                    $$('StatePaymentGatewayContingencySwith').setValue(0);
                }
                if (text[0].IsActivateAllowSendSms == 'A') {
                    $$('StateAllowSendSmsSwith').setValue(1);
                } else {
                    $$('StateAllowSendSmsSwith').setValue(0);
                }
                if (text[0].IsActivateAllowSendEmail == 'A') {
                    $$('StateAllowSendEmailSwith').setValue(1);
                } else {
                    $$('StateAllowSendEmailSwith').setValue(0);
                }
                if (text[0].IsActivateAllowSendPhone == 'A') {
                    $$('StateAllowSendPhoneSwith').setValue(1);
                } else {
                    $$('StateAllowSendPhoneSwith').setValue(0);
                }
                if (text[0].IsActivateAllowSendPush == 'A') {
                    $$('StateAllowSendPushSwith').setValue(1);
                } else {
                    $$('StateAllowSendPushSwith').setValue(0);
                }
                if (text[0].IsActivateAdvertising == 'A') {
                    $$('StateAdvertisingSwith').setValue(1);
                } else {
                    $$('StateAdvertisingSwith').setValue(0);
                }
                if(text[0].Active2FAUsersOnline == 'A'){
                    $$('Active2FAUsersOnline').setValue(1); // Set 2FA switch to on
                }else {
                    $$('Active2FAUsersOnline').setValue(0);
                }
                if (text[0].RegisteredStradacarte === "S") {
                    $$("StradacarteStatusLabel").setHTML("Registrado en Stradacarte: <b>Sí</b>");
                    if ($$("StradacarteRegisterBtn")) {
                        $$("StradacarteRegisterBtn").disable();
                    }
                } else {
                    $$("StradacarteStatusLabel").setHTML("Registrado en Stradacarte: <b>No</b>");
                    if ($$("StradacarteRegisterBtn")) {
                        $$("StradacarteRegisterBtn").enable();
                    }
                }
                console.log(text); // Log the response data for debugging
            },
        }); // Placeholder for the initialization content
    }
}

// FILE DOCUMENTED